function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { TagEl } from "common/components/tag";
import { TagSize } from "common/components/tag/types";
import { ButtonEl } from "common/components/button";
import { TagInputEl } from "common/components/tag-input";
import { SlackAuthProblem } from "./types";
const containerSelector = ".mp-slack-channel-selector-container";
function RenderSlackAuthProblem(_ref) {
  let {
    cmp
  } = _ref;
  const {
    slackAuthProblem,
    selectedChannels
  } = cmp.state;
  const {
    t
  } = cmp.getContext("i18n");
  const hasChannels = !!selectedChannels.size;
  const message = slackAuthProblem === SlackAuthProblem.MissingSlackAuthScopesException ? t("subscriptions.reauthorize-slack-app") : t("subscriptions.add-mixpanel-to-slack");
  return /* @__PURE__ */ jsx("div", { sel: containerSelector, "data-sentry-component": "RenderSlackAuthProblem", "data-sentry-source-file": "template.tsx" }, hasChannels && /* @__PURE__ */ jsx("div", { sel: ".mp-slack-channel-selector-no-auth-channels" }, /* @__PURE__ */ jsx(ChannelsAsTags, { cmp, isReadonly: true })), /* @__PURE__ */ jsx(ButtonEl, { attrs: _objectSpread(_objectSpread({
    icon: "slack-logo",
    href: "/slack/oauth?slack_v2=true&use_internal_landing=true",
    target: "_blank"
  }, cmp.attr("button-theme") ? {
    theme: cmp.attr("button-theme")
  } : {}), cmp.attr("button-full-width") ? {
    "style-override": "a.mp-button-container .mp-button-content {\n              flex: none; width: auto;\n            }\n            :host {\n              width: 100%;\n            }\n            "
  } : {}), on: {
    click: cmp.handleReauthorizeClick
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, message));
}
function RenderReadonly(_ref2) {
  let {
    cmp
  } = _ref2;
  const channelArray = [...cmp.state.selectedChannels];
  return /* @__PURE__ */ jsx("div", { sel: containerSelector, "data-sentry-component": "RenderReadonly", "data-sentry-source-file": "template.tsx" }, channelArray.length !== 0 ? /* @__PURE__ */ jsx(ChannelsAsTags, { cmp, isReadonly: true }) : /* @__PURE__ */ jsx("div", { sel: ".mp-slack-channel-selector-no-slack-channels" }, cmp.getContext("i18n").t("subscriptions.no-slack-channels")));
}
function ChannelsAsTags(_ref3) {
  let {
    cmp,
    isReadonly
  } = _ref3;
  const channelArray = [...cmp.state.selectedChannels];
  return /* @__PURE__ */ jsx(null, null, channelArray.map((_ref4) => {
    let [channelId, channel] = _ref4;
    return /* @__PURE__ */ jsx(TagEl, { attrs: {
      removable: !isReadonly,
      clickable: false,
      size: TagSize.Small,
      "tag-name": channel.name
    }, key: "channel-".concat(channelId), on: {
      remove: () => cmp.deselectChannelById(channel.id)
    } });
  }));
}
export function template() {
  if (this.attr("is-readonly")) {
    return /* @__PURE__ */ jsx(RenderReadonly, { cmp: this });
  }
  if (this.state.slackAuthProblem) {
    return /* @__PURE__ */ jsx(RenderSlackAuthProblem, { cmp: this });
  }
  return /* @__PURE__ */ jsx("div", { sel: containerSelector, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(TagInputEl, { attrs: {
    id: "picker",
    tags: this.getChannelsAsTags(),
    elref: "sharingTagInput",
    placeholder: this.getContext("i18n").t("subscriptions.channel-placeholder"),
    "min-tags": 0,
    disable: this.attr("is-readonly"),
    multiline: true
  }, on: {
    change: this.handleTagInputChange,
    clickMenuItem: this.handleItemClick
  }, props: {
    menuSections: this.getSlackChannelsForItemsMenu()
  }, "data-sentry-element": "TagInputEl", "data-sentry-source-file": "template.tsx" }));
}
